import React from "react";
import styles from "./EmptyEqueuesListMessage.style"
import {Button, Text} from "@vkontakte/vkui";
import {connect} from "react-redux";
import {setActivePanel} from "../../../redux/actions/panelsActions";
import {panels} from "../../../variables";

const EmptyEqueuesListMessage = ({goToStartOrderPage}) => {
    return(
        <>
            <Text style ={{
                ...styles.text,
                ...styles.firstLine
            }}>Здесь будет храниться история</Text>
            <Text style ={{
                ...styles.text,
                ...styles.secondLine
            }}>Ваших записей к врачу</Text>
            <Button
                onClick={() => goToStartOrderPage()}
                style={styles.orderButton}>
                Записаться к врачу
            </Button>
        </>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        goToStartOrderPage: () => dispatch(setActivePanel(panels.regionAndMedicalOrganisation))
    }
}
export default connect(null, mapDispatchToProps)(EmptyEqueuesListMessage);